import { FC } from 'react'
import { AppsRoutes, useAppsNavigate } from '@wellesley/router'
import { Dot, Settings } from 'lucide-react'
import { cn } from '@wellesley/ui'

type TranslationControlsProps = {
  className?: string
  isShowingTranslation: boolean
  isLoading: boolean
  onTranslate: () => Promise<void>
  onShowOriginal: () => void
}

const TranslationControls: FC<TranslationControlsProps> = ({
  className,
  isShowingTranslation,
  isLoading,
  onTranslate,
  onShowOriginal,
}) => {
  const navigate = useAppsNavigate()

  return (
    <div className={cn('text-base text-gray-500', className)}>
      {isShowingTranslation ? (
        <div className="flex content-center items-center gap-[2px]">
          <button
            onClick={onShowOriginal}
            data-prevent="true"
            className="hover:text-gray-700"
          >
            See the original
          </button>
          <Dot size={14} />
          <button
            aria-label="Settings"
            data-prevent="true"
            data-testid="settings-button"
            className="hover:text-gray-700"
            onClick={() => {
              navigate('/settings/languages' as AppsRoutes)
            }}
          >
            <Settings size={18} className="pointer-events-none" />
          </button>
        </div>
      ) : (
        <button data-prevent="true" onClick={() => void onTranslate()}>
          {isLoading ? 'Translating...' : 'Translate'}
        </button>
      )}
    </div>
  )
}

export default TranslationControls
